import { CopyAllButton } from 'components/shared/CopyAllButton/CopyAllButton';
import { useCopyChartToClipboard } from 'components/shared/Highcharts/use-copy-chart-to-clipboard';
import type { Options } from 'highcharts';
import type { HighchartsReactRefObject } from 'highcharts-react-official';
import type { ComponentType, RefObject } from 'react';
import { useRef, useState } from 'react';

interface ChartProps {
  chartComponentRef: RefObject<HighchartsReactRefObject | null>;
  highchartsOptions: Options;
}

export interface HighchartsExportWrapperProps {
  hasCopyToClipBoard?: boolean;
  highchartsOptions: Options;
  Chart: ComponentType<ChartProps>;
}

export function HighchartsExportWrapper({
  highchartsOptions,
  hasCopyToClipBoard = false,
  Chart,
}: HighchartsExportWrapperProps) {
  const chartComponentRef = useRef<HighchartsReactRefObject>(null);
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null);
  const imgOptions = { chart: chartComponentRef.current?.chart, canvas: canvasRef };
  const copyChart = useCopyChartToClipboard(imgOptions);
  return (
    <div className="d-flex flex-column">
      <Chart chartComponentRef={chartComponentRef} highchartsOptions={highchartsOptions} />
      <canvas ref={setCanvasRef} style={{ display: 'none' }}></canvas>
      {hasCopyToClipBoard && (
        <div className="d-flex justify-content-end mt-1">
          <CopyAllButton className="" onClick={copyChart}></CopyAllButton>
        </div>
      )}
    </div>
  );
}
